import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Head from "../../elements/head/head";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import api from "../../api";
import TextField from "@mui/material/TextField";
import "./zayavka.scss";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import { useMask } from "@react-input/mask";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Progress from "../../elements/progress/progress";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_MEDIA } from "../../env";
import Tooltip from "@mui/material/Tooltip";
import Captcha from "../../elements/capcha/capcha";
import Paper from "@mui/material/Paper";
import Footer from "../../elements/footer/footer";

const Main_Paper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.body,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Zayavka = (args) => {
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.userSelector.token);
  const captchaSelect = useSelector((state) => state.captchaSelector.captcha);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [first_name_error, setFirst_name_error] = useState(false);
  const [first_name_error_helper_text, setFirst_name_error_helper_text] =
    useState("");

  const [last_name_error, setLast_name_error] = useState(false);
  const [last_name_error_helper_text, setLast_name_error_helper_text] =
    useState("");

  const [third_name_error, setThird_name_error] = useState(false);
  const [third_name_error_helper_text, setThird_name_error_helper_text] =
    useState("");

  const [coach_name_error, setCoach_name_error] = useState(false);
  const [coach_name_error_helper_text, setCoach_name_error_helper_text] =
    useState("");

  const [sorev_name_error, setSorev_name_error] = useState(false);
  const [sorev_name_error_helper_text, setSorev_name_error_helper_text] =
    useState("");

  const [best_sum_error, setBest_sum_error] = useState(false);
  const [best_sum_error_helper_text, setBest_sum_error_helper_text] =
    useState("");

  const [email_error, setEmail_error] = useState(false);
  const [email_error_helper_text, setEmail_error_helper_text] = useState("");

  const [last_name, setLast_name] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [third_name, setThird_name] = useState("");
  const [phone, setPhone] = useState("");
  const [date_birth, setDate_birth] = useState(null);
  const [email, setEmail] = useState("");
  const [razrad, setRazrad] = useState("б/р");
  const [ves_kat, setVes_kat] = useState("53");
  const [but_dis, setBut_dis] = useState(false);
  const [sorev_name, setSorev_name] = useState("");
  const [coach_name, setCoach_name] = useState("");
  const [best_sum, setBest_sum] = useState("");

  const inputRef = useMask({
    mask: "+7(___) ___-__-__",
    replacement: { _: /\d/ },
    showMask: "+0 (123) ___-__-__",
  });

  const getUser = () => {
    setLoading(true);
    api.getDateUser(token).then((response) => {
      if (response.data.sportsmen) {
        setLast_name(response.data.sportsmen[0].last_name);
        setFirst_name(response.data.sportsmen[0].first_name);
        setThird_name(response.data.sportsmen[0].third_name);
        setPhone(response.data.sportsmen[0].phone);
        setDate_birth(response.data.sportsmen[0].date_birth);
        setEmail(response.data.sportsmen[0].email);
        setRazrad(response.data.sportsmen[0].razrad);
        setVes_kat(response.data.sportsmen[0].ves_kat);
      }
    });
    setLoading(false);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  // function getCookie(name) {
  //   let cookieValue = null;
  //   if (document.cookie && document.cookie !== "") {
  //     const cookies = document.cookie.split(";");
  //     for (let i = 0; i < cookies.length; i++) {
  //       const cookie = cookies[i].trim();
  //       if (cookie.substring(0, name.length + 1) === name + "=") {
  //         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
  //         break;
  //       }
  //     }
  //   }
  //   return cookieValue;
  // }

  const Sportsmen = () => {
    if (
      last_name &&
      first_name &&
      email &&
      sorev_name &&
      coach_name &&
      best_sum &&
      captchaSelect
    ) {
      // setBut_dis(false);
      api
        .postZayavka(
          first_name,
          last_name,
          email,
          third_name,
          phone,
          date_birth,
          razrad,
          ves_kat,
          best_sum,
          sorev_name,
          coach_name,
        )
        .then((response) => {
          setMessage("Ваше письмо успешно отправлено");
          setLast_name("");
          setFirst_name("");
          setThird_name("");
          setPhone("");
          setDate_birth(null);
          setEmail("");
          setRazrad("б/р");
          setVes_kat("53");
          setBut_dis(false);
          setSorev_name("");
          setCoach_name("");
          setBest_sum("");

          setFirst_name_error(false);
          setLast_name_error(false);
          setEmail_error(false);
          setSorev_name_error(false);
          setCoach_name_error(false);
          setBest_sum_error(false);
        })
        .catch((error) => {
          console.error("Ошибка сервера:", error.response.data);
        });
    } else {
      // dispatch(setCaptcha(false));
      setFirst_name_error(true);
      setLast_name_error(true);
      setEmail_error(true);
      setSorev_name_error(true);
      setCoach_name_error(true);
      setBest_sum_error(true);
      // setBut_dis(true);
    }
  };

  const handleChangeFirst_name = (event) => {
    const value = event.target.value;
    setFirst_name(value);
    if (value.length < 2) {
      setFirst_name_error(true);
      setFirst_name_error_helper_text(
        "Имя не должно содержать менее 2 символов.",
      );
    } else if (value.length > 50) {
      setFirst_name_error(true);
      setFirst_name_error_helper_text(
        "Имя не должно содержать более 50 символов.",
      );
    } else {
      setFirst_name_error(false);
      setFirst_name_error_helper_text("");
    }
  };

  const handleChangeLast_name = (event) => {
    const value = event.target.value;
    setLast_name(value);
    if (value.length < 2) {
      setLast_name_error(true);
      setLast_name_error_helper_text(
        "Фамилия должна содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setLast_name_error(true);
      setLast_name_error_helper_text(
        "Фамилия не должна содержать более 50 символов.",
      );
    } else {
      setLast_name_error(false);
      setLast_name_error_helper_text("");
    }
  };

  const handleChangeThird_name = (event) => {
    const value = event.target.value;
    setThird_name(value);
    if (value.length < 2) {
      setThird_name_error(true);
      setThird_name_error_helper_text(
        "Фамилия должна содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setThird_name_error(true);
      setThird_name_error_helper_text(
        "Фамилия не должна содержать более 50 символов.",
      );
    } else {
      setThird_name_error(false);
      setThird_name_error_helper_text("");
    }
  };

  const handleChangeSorev_name = (event) => {
    const value = event.target.value;
    setSorev_name(value);
    if (value.length < 2) {
      setSorev_name_error(true);
      setSorev_name_error_helper_text(
        "Поле не должно содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setSorev_name_error(true);
      setSorev_name_error_helper_text(
        "Поле не должно содержать более 500 символов.",
      );
    } else {
      setSorev_name_error(false);
      setSorev_name_error_helper_text("");
    }
  };

  const handleChangeCoach_name = (event) => {
    const value = event.target.value;
    setCoach_name(value);
    if (value.length < 2) {
      setCoach_name_error(true);
      setCoach_name_error_helper_text(
        "Поле не должно содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setCoach_name_error(true);
      setCoach_name_error_helper_text(
        "Поле не должно содержать более 100 символов.",
      );
    } else {
      setCoach_name_error(false);
      setCoach_name_error_helper_text("");
    }
  };

  const handleChangeBest_sum = (event) => {
    const value = event.target.value;
    setBest_sum(value);
    if (value.length < 2) {
      setBest_sum_error(true);
      setBest_sum_error_helper_text(
        "Поле не должно содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setBest_sum_error(true);
      setBest_sum_error_helper_text(
        "Поле не должно содержать более 500 символов.",
      );
    } else {
      setBest_sum_error(false);
      setBest_sum_error_helper_text("");
    }
  };

  const handleChangeEmail = (event) => {
    const value = event.target.value;
    setEmail(value);
    if (validateEmail(value)) {
      setEmail_error(false);
      setEmail_error_helper_text("");
    } else {
      setEmail_error(true);
      setEmail_error_helper_text("Некорректное значение Email");
    }
  };

  useEffect(() => {
    getUser(token);
  }, [token]);
  // useEffect(() => {
  //   getUser();
  // }, [avatar]);
  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={12}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={12} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          <Main_Paper>
            <Grid
              spacing={1}
              container
              direction="rows"
              sx={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid size={12}>
                <Item>
                  <Typography variant="h6" gutterBottom>
                    ЗАЯВКА НА СОРЕВНОВАНИЕ(ДЛЯ ЧЛЕНОВ СБОРНОЙ)
                  </Typography>
                </Item>
              </Grid>
              <Grid size={12}>
                <Item>
                  <Divider>ЛИЧНЫЕ ДАННЫЕ</Divider>
                </Item>
              </Grid>

              <Grid size={12} container>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={last_name}
                      sx={{ width: "100%" }}
                      onChange={handleChangeLast_name}
                      onfo
                      id="last_name"
                      label="Фамилия"
                      variant="outlined"
                      error={last_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={last_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={first_name}
                      sx={{ width: "100%" }}
                      onChange={handleChangeFirst_name}
                      onfo
                      id="first_name"
                      label="Имя"
                      variant="outlined"
                      error={first_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={first_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={third_name}
                      sx={{ width: "100%" }}
                      onChange={handleChangeThird_name}
                      onfo
                      id="third_name"
                      label="Отчество"
                      variant="outlined"
                      error={third_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={third_name_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={email}
                      onChange={handleChangeEmail}
                      onfo
                      id="email"
                      label="Емаил"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={email_error}
                      type="email"
                      slotProps={{ inputLabel: { shrink: true } }}
                      required
                      helperText={email_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      id="phone"
                      value={phone}
                      label="Номер телефона"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={false}
                      inputRef={inputRef}
                      slotProps={{ inputLabel: { shrink: true } }}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Item>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={date_birth}
                      onChange={(e) => setDate_birth(e.target.value)}
                      onfo
                      id="date_birth"
                      label="Дата рождения"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={false}
                      type="date"
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                  </Item>
                </Grid>
              </Grid>

              <Grid size={12} container>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Разряд
                      </InputLabel>
                      <Select
                        id="razrad"
                        select
                        value={razrad}
                        label="Разряд"
                        onChange={(e) => setRazrad(e.target.value)}
                        error={false}
                        helperText="Выберете значение"
                      >
                        <MenuItem value={"б/р"}>б/р</MenuItem>
                        <MenuItem value={"III ЮН"}>III ЮН</MenuItem>
                        <MenuItem value={"II ЮН"}>II ЮН</MenuItem>
                        <MenuItem value={"I ЮН"}>I ЮН</MenuItem>
                        <MenuItem value={"III"}>III</MenuItem>
                        <MenuItem value={"II"}>II</MenuItem>
                        <MenuItem value={"I"}>I</MenuItem>
                        <MenuItem value={"КМС"}>КМС</MenuItem>
                        <MenuItem value={"МС"}>МС</MenuItem>
                        <MenuItem value={"МСМК"}>МСМК</MenuItem>
                      </Select>
                    </FormControl>
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Весовая категория
                      </InputLabel>
                      <Select
                        id="ves_kat"
                        select
                        value={ves_kat}
                        label="Весовая категория"
                        onChange={(e) => setVes_kat(e.target.value)}
                        error={false}
                        helperText="Выберете значение"
                      >
                        <MenuItem value={"53"}>53</MenuItem>
                        <MenuItem value={"59"}>59</MenuItem>
                        <MenuItem value={"66"}>66</MenuItem>
                        <MenuItem value={"74"}>74</MenuItem>
                        <MenuItem value={"83"}>83</MenuItem>
                        <MenuItem value={"93"}>93</MenuItem>
                        <MenuItem value={"105"}>105</MenuItem>
                        <MenuItem value={"120"}>120</MenuItem>
                        <MenuItem value={"120+"}>120+</MenuItem>
                        <MenuItem value={"43"}>43-жен</MenuItem>
                        <MenuItem value={"47"}>47-жен</MenuItem>
                        <MenuItem value={"52"}>52-жен</MenuItem>
                        <MenuItem value={"57"}>57-жен</MenuItem>
                        <MenuItem value={"63"}>63-жен</MenuItem>
                        <MenuItem value={"69"}>69-жен</MenuItem>
                        <MenuItem value={"72"}>72-жен</MenuItem>
                        <MenuItem value={"76"}>76-жен</MenuItem>
                        <MenuItem value={"84"}>84-жен</MenuItem>
                        <MenuItem value={"84+"}>84+жен</MenuItem>
                      </Select>
                    </FormControl>
                  </Item>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                  <Item>
                    <Divider>СОРЕВНОВАНИЕ</Divider>
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={handleChangeSorev_name}
                      onfo
                      id="sorev_name"
                      label="Название соревнования"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={sorev_name_error}
                      value={sorev_name}
                      slotProps={{ inputLabel: { shrink: true } }}
                      multiline
                      rows={4}
                      helperText={sorev_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={handleChangeCoach_name}
                      onfo
                      id="coach_name"
                      label="ФИО тренера/лично"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={coach_name_error}
                      value={coach_name}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={coach_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={handleChangeBest_sum}
                      onfo
                      id="best_sum"
                      label="Лучший результат, где показан (в течение года)"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={best_sum_error}
                      value={best_sum}
                      slotProps={{ inputLabel: { shrink: true } }}
                      multiline
                      rows={4}
                      helperText={best_sum_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Item>
                  <Divider>ОТПРАВКА ДАННЫХ</Divider>
                </Item>
              </Grid>

              <Grid container spacing={1}>
                <Captcha />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                <Item>
                  <Tooltip title="Нажмите для отправки заявки">
                    <But
                      disabled={but_dis}
                      variant="outlined"
                      onClick={() => Sportsmen()}
                    >
                      Отправить заявку
                    </But>
                  </Tooltip>
                </Item>

                <Item>{message}</Item>
              </Grid>
              {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                  <Item>
                    <Divider></Divider>
                  </Item>
                </Grid> */}
            </Grid>
          </Main_Paper>
        </Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Zayavka;
